import React from 'react'
import { Modal } from 'react-bootstrap'
import PoolTimerUI from './PoolTimerUI'
import { formatSmartDecimal, formatNumberWithCommas, getTokenSymbol, formatCreatorName, formatProposerName, formatDates, formatTimeTo12Hour, isStableTokenSymbol } from '../../utils/helpers'
import { DARK_THEME } from '../../utils/constants'
import { useTheme } from '../../contexts/ThemeProvider'
import { useSwipeClose } from '../../hooks/useSwipeClose'


const MarketRulesMobileModal = ({
    show,
    onHide,
    totalSumVolumn,
    tokenToDisplay,
    tokenSymbol,
    parsedPoolVolumn,
    tokenPriceToUsdt,
    allliquidity,
    totalSumLiquidity,
    poolstart,
    poolend,
    poolsdetail,
    setPollStatus,
    setIsDisabled,
}) => {
    const potSize = +allliquidity < 0
        ? 0
        : +totalSumLiquidity > 0
            ? formatNumberWithCommas(+totalSumLiquidity + +allliquidity)
            : formatNumberWithCommas(+allliquidity);

    const isAiResolver = poolsdetail?.isAiResolver;
    const isResolved = poolsdetail?.poolFinalized && poolsdetail?.winnerOption;
    const winnerProposer = poolsdetail?.winnerProposer;

    const {theme} = useTheme();

    const swipeRef = useSwipeClose(show, onHide);

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                centered
                className="pollmodal sharesocial-modal new-modal-style marketrules-modal"
                animation={false}
            >
                <Modal.Header ref={swipeRef} onClick={onHide}>
                    <div className="close-div" ></div>
                </Modal.Header>
                <Modal.Body>
                    <div className="resolution-method">
                        <div className="upper-box">
                            <div className="single-value">
                                <p>Created by</p>
                                <h6>
                                    <img src={poolsdetail?.poolOwnerprofilePic} alt="img" className="img-fluid" style={{ width: "18px", height: "18px", borderRadius: "50%" }} /> {formatCreatorName(poolsdetail)}
                                    <span>{poolsdetail?.createdAt ? `${formatDates(poolsdetail.createdAt)} - ${formatTimeTo12Hour(poolsdetail.createdAt)}` : ''}</span>
                                </h6>
                            </div>
                            <div className="single-value">
                                <p>Resolution Method</p>
                                <h6>{isAiResolver ? <>{
                                    theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px", width: "auto", height: "auto", borderRadius: "unset" }} /> :
                                        <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px", width: "auto", height: "auto", borderRadius: "unset" }} />
                                }</> : 'Manual Resolution'}</h6>
                            </div>
                        </div>
                        {isResolved && !isAiResolver && winnerProposer && (
                            <div className="upper-box">
                                <div className="single-value">
                                    <p>Closed by</p>
                                    <h6>
                                        <img src={winnerProposer?.user?.profilePic} alt="img" className="img-fluid" style={{ width: "18px", height: "18px", borderRadius: "50%" }} /> {formatProposerName(winnerProposer)}
                                        <span>{winnerProposer?.createdAt ? `${formatDates(winnerProposer.createdAt)} - ${formatTimeTo12Hour(winnerProposer.createdAt)}` : ''}</span>
                                    </h6>
                                </div>
                            </div>
                        )}
                        {isResolved && isAiResolver && winnerProposer && (
                            <div className="upper-box">
                                <div className="single-value">
                                    <p> {isAiResolver ? "Triggered by" : "Closed by"}</p>
                                    <h6>
                                        <img src={winnerProposer?.user?.profilePic} alt="img" className="img-fluid" style={{ width: "18px", height: "18px", borderRadius: "50%" }} /> {formatProposerName(winnerProposer)}
                                        <span>{winnerProposer?.createdAt ? `${formatDates(winnerProposer.createdAt)} - ${formatTimeTo12Hour(winnerProposer.createdAt)}` : ''}</span>
                                    </h6>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="top-box">
                        <div className="single-value">
                            <p>Total Volume</p>
                            <h6>{totalSumVolumn} {tokenToDisplay}</h6>
                            {!isStableTokenSymbol(tokenSymbol) && (
                                <p>${formatSmartDecimal(+tokenPriceToUsdt * +parsedPoolVolumn)}</p>
                            )}
                        </div>
                        <div className="single-value">
                            <p>Pot Size</p>
                            <h6>{potSize} {tokenToDisplay}</h6>
                            {!isStableTokenSymbol(tokenSymbol) && (
                                <p>${formatSmartDecimal(tokenPriceToUsdt * (+totalSumLiquidity + +allliquidity))}</p>
                            )}
                        </div>
                        <PoolTimerUI
                            poolstart={poolstart}
                            poolend={poolend}
                            poolsdetail={poolsdetail}
                            setPollStatus={setPollStatus}
                            setIsDisabled={setIsDisabled}
                        />
                        <div className="single-value">
                            <p>Trade with</p>
                            <h6>{getTokenSymbol(tokenSymbol, true)}{tokenToDisplay}</h6>
                        </div>
                    </div>
                    <div className="market-rules-box">
                        <h6>Market Rules</h6>
                        <div className="bottom-detail">
                            {poolsdetail?.poolDescription
                                ? <p>{poolsdetail.poolDescription}</p>
                                : <p>No description available.</p>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MarketRulesMobileModal
